
export interface TransferOfChargeBulkEditCriteria {
    ids: number[],
    chargeOnCompany?: string | null,
    billToCompany?: string | null,
    paidThroughDate?: Date | null,
    exciseCashNo?: string | null,
    accTmlResume?: boolean,
    holdOrUnHold?: boolean,
    accTmlReasonCode?: string | null,



    [key: string]: string | number | number[] | Date | boolean | null | undefined
}

export const EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA: TransferOfChargeBulkEditCriteria = {
    ids: [],
    chargeOnCompany: '',
    billToCompany: '',
    paidThroughDate: null,
    exciseCashNo: '',
    accTmlReasonCode: '',

}